import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useSegmentLogoPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canSee, canCreate, canUpdate, canDelete } = useMemo(
    () => ({
      canSee: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.VIEW_SEGMENT_LOGO]),
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_SEGMENT_LOGO]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_SEGMENT_LOGO]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_SEGMENT_LOGO]),
    }),
    [hasPlatformPermission]
  );

  return {
    canSee,
    canCreate,
    canUpdate,
    canDelete,
  };
};
